import { useRef, useEffect } from 'react'
import anime from 'animejs'
import { Box } from '@chakra-ui/react'

import { ReactComponent as Image } from '@/svg/services/vendor.svg'

interface Props {
  animate?: boolean
}

function RecruitmentImage({ animate = true }: Props): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current && animate) {
      const animInstances: anime.AnimeInstance[] = []

      return () =>
        animInstances.forEach((instance: anime.AnimeInstance) =>
          instance.pause(),
        )
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {}
  }, [containerRef.current, animate])

  return (
    <Box
      ref={containerRef}
      sx={{
        '& > svg *': {
          transformBox: 'fill-box',
        },
      }}
    >
      <Image />
    </Box>
  )
}
export default RecruitmentImage
